import { useQuery, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import { useLocationId } from '@/data/useLocationId';

type GrowthQueryOptions<T> = Omit<
  UseQueryOptions<T, Error, T, readonly unknown[]>,
  'queryKey' | 'queryFn' | 'enabled'
> & {
  queryKey: readonly unknown[];
  queryFn: () => Promise<T>;
  /** Extra gate (e.g. route param present). Location must still be selected. */
  enabled?: boolean;
};

/** Location-gated query — matches Recall/FrontDesk: no fetch until location is selected. */
export function useGrowthQuery<T>(options: GrowthQueryOptions<T>): UseQueryResult<T, Error> {
  const locationId = useLocationId();
  const extraEnabled = options.enabled ?? true;

  return useQuery({
    ...options,
    queryKey: [...options.queryKey, locationId],
    enabled: locationId != null && extraEnabled,
  });
}
